export function ExportEmailProductCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  company,
  limited,
  messages,
  product_limit,
  product_offset,
  workshopAPI
) {

  $scope.company        = company;
  $scope.export_type    = $translate.instant('PRODUCT_SPACE.PRODUCT');
  $scope.limited        = limited;
  $scope.product_limit  = product_limit;
  $scope.product_offset = product_offset;

  $scope.email_export = function () {
    const url = $scope.limited ? '/products/product_csv_customer_export' : '/products/product_csv_admin_export';

    workshopAPI.post(url, {
      email: $scope.email,
      page_size: $scope.product_limit,
      offset: $scope.product_offset,
      company_id: $scope.company.id
    }, 'product_data').then(() => {
      messages.show($translate.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', { email: $scope.email }), 'success');
      $uibModalInstance.close();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };
}